import React from "react"
import { format } from "date-fns";

const LinkedBookInJobs = ({
  bookedInJobServices
}) => {
  const bookedInJobServiceLine = jobService => {
    const {
      bookingTime, label
    } = jobService

    return (
      <p>
        <a href={`/jobs/${jobService.jobId}/job_services/${jobService.id}`} className="text-dark">
          {`${format(new Date(bookingTime), "dd MMM yyyy, h:mm aa")} - ${label}`}
        </a>
      </p>
    )
  }

  return (
    <div className="timeline-item mt-2">
      <div className="card border-0 shadow-sm">
        <div className="card-body p-3">
          <div className="row align-items-center">
            <div className="col-sm-6">
            </div>
          </div>
          { bookedInJobServices.map(jobService => bookedInJobServiceLine(jobService)) }
        </div>

      </div>
    </div>
  )
}

export default LinkedBookInJobs